module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('nav', {
    attrs: {
      "aria-label": "breadcrumb"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, _vm._l((_vm.breadcrumbsData), function(route, index) {
    return _c('li', {
      key: index,
      staticClass: "breadcrumb-item",
      class: {
        active: route.selected
      }
    }, [(!route.selected) ? _c('a', {
      on: {
        "click": function($event) {
          _vm.onClick(route)
        }
      }
    }, [_vm._v(_vm._s(route.title))]) : _vm._e(), _vm._v("\n             " + _vm._s(route.selected ? route.title : null) + "\n          ")])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-88458236","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Breadcrumb.vue
// module id = 2188
// module chunks = 1